import { create } from 'zustand';

export interface ChatMessage {
  id: string;
  senderId: string;
  senderName: string;
  text: string;
  timestamp: number;
  type?: 'text' | 'system';
}

interface ChatState {
  messages: ChatMessage[];
  unreadCount: number;
  
  addMessage: (message: ChatMessage, isOwnMessage?: boolean) => void;
  removeMessage: (messageId: string) => void;
  clearMessages: () => void;
  markAsRead: () => void;
}

export const useChatStore = create<ChatState>((set) => ({
  messages: [],
  unreadCount: 0,

  addMessage: (message, isOwnMessage = false) =>
    set((state) => ({
      messages: [...state.messages, message],
      unreadCount: isOwnMessage ? state.unreadCount : state.unreadCount + 1,
    })),

  removeMessage: (messageId) =>
    set((state) => ({
      messages: state.messages.filter((message) => message.id !== messageId),
      unreadCount: state.unreadCount,
    })),

  clearMessages: () =>
    set({
      messages: [],
      unreadCount: 0,
    }),

  markAsRead: () =>
    set({
      unreadCount: 0,
    }),
}));
